export default __webpack_public_path__ + "sounds/Debris-9e296daee23420c59b2d5f4718e09a56.wav";